import { LogoComponent } from 'shared/components/site-layout/components/LogoComponent';

import { SubscriptionLogo } from 'shared/ui-kit';

import { Panel } from './components/panel';
import { Block } from './components/block';
import { Advantages } from './components/advantages';
import { Subscriptions } from './components/subscriptions';

import { SubscriptionPlanViewModel } from './model/subscriptions';

import styles from './layout.module.scss';

export interface SubscriptionSelectLayoutProps {
	subscriptionPlans: SubscriptionPlanViewModel[];
}
export const SubscriptionSelectLayout = (props: SubscriptionSelectLayoutProps) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.container}>
				<h1 className={styles.header}>Подписка на <LogoComponent /></h1>
				<div className={styles.content}>
					<Panel title="Бесплатно" className={styles.content_item}>
						<Block title="Свободный доступ к данным">
							<Advantages isFree={true} />
						</Block>
					</Panel>
					<Panel title={<SubscriptionLogo />} className={styles.content_item} contentClassName={styles.content_item_subscription}>
						<Block title="Больше возможностей">
							<Advantages isFree={false} />
						</Block>
						<Block title="Выберите подписку">
							<Subscriptions plans={props.subscriptionPlans} />
						</Block>
					</Panel>
				</div>
			</div>
		</div>
	);
}